import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {MedicalRecordSportModel} from '../../model/medicalRecordSport.model';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {PartnerType} from '../../../../../../partner/common/api/model/partnerSummary.model';
import {LovValueModalOptions} from '../../../../../../common/lov/lov-value/api/model/lovValueModalOptions';
import {MedicalSportSavePayload} from '../../../impl/service/payload/medicalSportSave.payload';
import {TranscriptionConfig} from '../../../../../../common/audio/transcription/api/component/audio-transcription/audio-transcription.component';
import {
    AudioTranscriptionConfig
} from "../../../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";

@Component({
    selector: 'app-medical-record-sport-save-form',
    templateUrl: './medical-record-sport-save-form.component.html',
})
export class MedicalRecordSportSaveFormComponent implements OnChanges {

    @Input() formGroup: UntypedFormGroup;
    @Input() partnerId: number;
    @Input() consultationId: number;
    @Input() id: number;
    @Input() entity: MedicalRecordSportModel;
    @Input() initialPayload: MedicalSportSavePayload;
    @Input() audioTranscriptionConfig: AudioTranscriptionConfig;

    PartnerType = PartnerType;

    newSportModalProps: LovValueModalOptions = {
        title: 'un sport',
    };

    constructor(private formBuilder: UntypedFormBuilder) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['entity'] && this.entity) {
            this.entityLoaded(this.entity);
        }

        if (changes['formGroup'] && this.formGroup) {
            this.formGroup.addControl('id', this.formBuilder.control(this.id));
            this.formGroup.addControl('partnerId', this.formBuilder.control(this.partnerId, Validators.required));
            this.formGroup.addControl('sportLovValue', this.formBuilder.control('SPORT_OTHER', Validators.required));
            this.formGroup.addControl('typeLovValue', this.formBuilder.control(('MEDICAL_RECORD_SPORT_TYPE_LEISURE')));
            this.formGroup.addControl('frequencyLovValue', this.formBuilder.control('FREQUENCY_1_TIME_A_WEEK'));
            this.formGroup.addControl('flooringLovValue', this.formBuilder.control(undefined));
            this.formGroup.addControl('startYear', this.formBuilder.control(undefined));
            this.formGroup.addControl('endYear', this.formBuilder.control(undefined));
            this.formGroup.addControl('comment', this.formBuilder.control(undefined));
            this.formGroup.addControl('consultationId', this.formBuilder.control(undefined));

            this.applyInitialPayload();
        }

        if (changes['id']) {
            this.formGroup?.patchValue({
                id: this.id,
            });
        }

        if (changes['partnerId']) {
            this.formGroup?.patchValue({
                partnerId: this.partnerId
            });
        }

        if (changes['consultationId']) {
            this.formGroup?.patchValue({
                consultationId: this.consultationId
            });
        }

        if (changes['initialPayload']) {
            this.applyInitialPayload();
        }

    }

    applyInitialPayload() {
        if (this.initialPayload) {
            this.formGroup?.patchValue(this.initialPayload);
        }
    }

    entityLoaded(entity: MedicalRecordSportModel) {
        this.formGroup?.patchValue({
            id: entity.id,
            partnerId: entity.partner.id,
            sportLovValue: entity.sport?.value,
            typeLovValue: entity.type?.value,
            frequencyLovValue: entity.frequency?.value,
            flooringLovValue: entity.flooring?.value,
            startYear: entity.startYear,
            endYear: entity.endYear,
            comment: entity.comment,
            consultationId: entity.consultation?.id,
        });
    }
}
